import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import store from '../src/store';
import Loader from '../src/uilib/loader';
import H3ErrorBoundryApp from './components/AppContainer/ErrorBoundry';
import './scss/main.scss';
import './scss/ant-grid.scss';
import ScrollToTop from './ScrollToTop';
import App from './app';
import * as Sentry from '@sentry/react';
import releaseConfig from '../config.json';
// ✅ Create QueryClient instance
const queryClient = new QueryClient();
const cfBranch = ["app.procuzy.com"].some(domain => window.location.href.includes(domain));
if (cfBranch) {
    Sentry.init({
        dsn: 'https://b010a33d76afbdc1f4729626ff44831d@o4507922678939648.ingest.us.sentry.io/4509524130791424',
        environment: window.location.href.includes("localhost:3500") ? 'local' : 'production',
        release: `procuzy@${releaseConfig?.currentVersion}`, // cast to any if needed
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 0.03,
        tracePropagationTargets: [/^https:\/\/app\.procuzy\.com/],
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'Non-Error promise rejection captured',
            'TurnstileError',
            '[Cloudflare Turnstile] Error:',
            'sendApiLog',
        ],
        beforeSend(event) {
            const message = event?.exception?.values?.[0]?.value || '';
            const type = event?.exception?.values?.[0]?.type || '';
            if (message.includes('ResizeObserver loop') ||
                message.includes('ChunkLoadError') ||
                message.includes('TurnstileError') ||
                message.includes('[Cloudflare Turnstile] Error:') ||
                type.includes('TurnstileError') ||
                message.includes('sendApiLog') ||
                type.includes('sendApiLog')) {
                return null;
            }
            return event;
        },
    });
}
String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};
// if (!String.prototype.replaceAll) {
//   String.prototype.replaceAll = function (find: string, replace: string): string {
//     const escapedFind = find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//     const regex = new RegExp(escapedFind, "g");
//     return this.replace(regex, replace);
//   };
// }
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error("Root element not found");
}
const root = createRoot(rootElement);
const AppWithRouter = () => (_jsx(Provider, { store: store, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsxs(Router, { children: [_jsx(ScrollToTop, {}), _jsx(Loader, {}), _jsxs(H3ErrorBoundryApp, { children: [_jsx(App, {}), _jsx(ReactQueryDevtools, { initialIsOpen: false })] })] }) }) }));
root.render(_jsx(AppWithRouter, {}));
